module.exports = __webpack_public_path__ + "media/images/dashboard-img-44a2ae745be8f7615baaef4d1483513a.png";